<script setup lang="ts">
import type { AgentOnPage } from '@@/shared/agent/api-types';
import type { AgentOnList } from '@@/shared/agent/types';
import type { PropertyOnPage } from '@@/shared/property/api-types';
import type { BtnSize } from '~/components/iad/btn/types';

const props = defineProps<{
  size?: BtnSize
  icon?: boolean
  agent: AgentOnPage | AgentOnList
  property?: PropertyOnPage
}>();

const alreadyReveal = ref(false);

const commonParams = computed(() => {
  return {
    agent_id: props.agent.localId,
    property_id: props.property?.propertyListingRef,
    property_category: getTrackingPropertyCategory(props.property),
  };
});

function revealPhone() {
  trackEvent({
    event: 'agent_interaction',
    event_name: 'click_to_call',
    ...commonParams.value,
  });
  // track the event only once time
  if (!alreadyReveal.value) {
    trackEvent({
      event: 'generate_lead',
      lead_category: 'buyer',
      lead_type: 'contact_by_phone',
      ...commonParams.value,
    });
  }
  alreadyReveal.value = true;
}
</script>

<template>
  <IadBtnPhone
    :size
    :icon
    :hashed-phone="agent.hashedPhone"
    @click="revealPhone"
  />
</template>
